import { ButtonIcon } from "~styled/button"
import HighlightOffIcon from "@mui/icons-material/HighlightOffOutlined"

interface Props {
  onClick: (v) => void
}

const RemoveButton = ({ onClick }: Props) => (
  <ButtonIcon color={"transparent"} onClick={v => onClick(v)}>
    <HighlightOffIcon style={{ color: "white" }} />
  </ButtonIcon>
)

export default RemoveButton
